import React from 'react';

import {
  ContentDate,
  ContentDescription,
  ContentTitle,
  TableContentWrap,
} from './LabResultsCell.style';

function LabResultsCell({
  onClick,
  title = '',
  date,
  value = '',
}: {
  onClick?: () => void;
  title?: string | null;
  date?: string | null;
  value?: React.ReactNode;
}) {
  return (
    <TableContentWrap onClick={onClick}>
      <ContentTitle>{title}</ContentTitle>
      <ContentDate>{date ? date : null}</ContentDate>
      <ContentDescription>{value ?? ''}</ContentDescription>
    </TableContentWrap>
  );
}

export default LabResultsCell;
